<template>
  <div>
    <h4><i class="uil-books"></i> {{ $t('general.licensed_catalog_trainings') }}</h4>
    <div class="section-header pb-0 mb-4">
      <div class="section-header-left">
        <form action="" @submit.prevent="applyFilter">
          <input v-model="searchQuery"
                 :placeholder="$t('home.Education_shearing')"
                 class="mt-3"
                 type="text"
                 @input="isTyping = true"
          />
        </form>
      </div>
      <div class="section-header-right">
        <select v-model="orderBy" class="ml-3 mb-0" @change="applyFilter">
          <option value="name">{{ $t('filter.Filter_by_name') }}</option>
          <option value="training_type_id">{{ $t('filter.Filter_by_category') }}</option>
          <option value="created_at">{{ $t('filter.Filter_by_date') }}</option>
        </select>
      </div>
    </div>
    <div class="uk-width-2-3@m" style="width: 100%">
      <default-loading v-if="catalogLoading || initialLoading"></default-loading>
      <template v-else>
        <div class="card rounded uk-card-hover uk-card-small">
          <div class="card-header bg-white border-bottom-0 p-0">
            <div class="d-flex align-items-center justify-content-between p-3 pb-0">
              <div class="d-flex flex-column">
                <span class="text-muted font-weight-medium mb-2" style="font-size: 0.95rem;">
                  <i class="uil-books mr-2" style="font-size: 1.1rem;"></i>
                  {{ $t('general.catalog_trainings_displayed', { count: items ? items.total : 0 }) }}
                </span>

                <div v-if="showPerPage" class="d-flex align-items-center">
                  <span class="text-muted mr-2" style="font-size: 0.95rem;">{{ $t('general.per_page') }}:</span>
                  <select v-model="perPageValue"
                          class="form-control form-control-sm"
                          style="width: 100px;"
                          @change="applyFilter"
                  >
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="999999">{{ $t('general.all') }}</option>
                  </select>
                </div>

                <div class="custom-control custom-checkbox">
                  <input id="training-purchase-reg"
                         v-model="purchaseRegistrationLocal"
                         class="custom-control-input"
                         type="checkbox"
                         value="1"
                  />
                  <label class="custom-control-label"
                         for="training-purchase-reg"
                         style="font-size: 0.95rem; padding-top: 2px;"
                  >{{ $t('general.mark_as_purchased') }}</label>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-center p-3 border-top">
              <button class="btn btn-outline-primary btn-sm"
                      style="min-width: 120px; height: 32px;"
                      type="button"
                      @click="toggleSelectAll"
              >
                <i class="uil-check-square mr-2" style="font-size: 1rem;"></i>
                <span style="font-size: 0.95rem;">{{ selectAllText }}</span>
              </button>
              <button v-if="showAddAsContents && selectedIds.length > 0"
                      class="btn btn-primary btn-sm"
                      style="min-width: 180px; height: 32px;"
                      type="button"
                      @click="$emit('add-as-contents')"
              >
                <i class="uil-plus-circle mr-2" style="font-size: 1rem;"></i>
                <span style="font-size: 0.95rem;">{{ $t('general.add_selected_as_content') }}</span>
              </button>
            </div>
          </div>
          <template v-for="(subItem, index) in items.data" v-if="items && items.data && items.data.length">
            <hr class="m-0"/>
            <div class="catalog-training-card">
              <div class="catalog-training-card__checkbox">
                <input :id="'notification_checkbox_' + subItem.id"
                       v-model="selectedIds"
                       :value="subItem.id"
                       type="checkbox"
                />
              </div>
              <div class="catalog-training-card__image-wrap">
                <img :src="subItem.cover_image_link"
                     alt=""
                     class="catalog-training-image"
                />
              </div>
              <div class="catalog-training-card__body">
                <h5 class="catalog-training-card__title">{{ subItem.name }}</h5>
                <p class="catalog-training-card__meta">
                  <span class="catalog-training-card__badge">
                    {{
                      $t('education.section_count', { number: subItem.training_content_count }) +
                      ' / ' +
                      $t('education.content_count', { number: subItem.training_content_count })
                    }}
                  </span>
                </p>
                <p class="catalog-training-description">{{ subItem.description }}</p>
              </div>
            </div>
          </template>
        </div>
        <Pagination
            v-if="items && items.data && items.last_page !== 1"
            :page.sync="pageProxy"
            :paginate="items"
        ></Pagination>
      </template>
    </div>
  </div>
</template>

<script>
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import Pagination from "@/view/components/dataTable/Pagination";

export default {
  name: "CatalogTrainingList",
  components: {
    DefaultLoading,
    Pagination,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: [Object, Array],
      default: () => ({}),
    },
    catalogLoading: {
      type: Boolean,
      default: false,
    },
    trainingPurchaseRegistration: {
      type: Boolean,
      default: false,
    },
    showPerPage: {
      type: Boolean,
      default: false,
    },
    showAddAsContents: {
      type: Boolean,
      default: false,
    },
    perPage: {
      type: [Number, String],
      default: 10,
    },
  },
  data() {
    return {
      searchQuery: "",
      isTyping: false,
      orderBy: "name",
      page: 1,
      selectAllText: "",
      allTraining: false,
      initialLoading: true,
    };
  },
  created() {
    this.selectAllText = this.$t("general.select_all");
  },
  computed: {
    selectedIds: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    purchaseRegistrationLocal: {
      get() {
        return this.trainingPurchaseRegistration;
      },
      set(val) {
        this.$emit("update:trainingPurchaseRegistration", val);
      },
    },
    perPageValue: {
      get() {
        return this.perPage;
      },
      set(val) {
        this.$emit("update:perPage", val);
      },
    },
    pageProxy: {
      get() {
        return this.page;
      },
      set(value) {
        this.page = value;
        this.applyFilter();
      },
    },
  },
  methods: {
    toggleSelectAll() {
      if (!this.items || !this.items.data) return;

      if (this.selectAllText === this.$t("general.select_all")) {
        let ids = [...this.selectedIds];
        this.items.data.forEach((training) => {
          if (!ids.includes(training.id)) {
            ids.push(training.id);
          }
        });
        this.selectedIds = ids;
        this.allTraining = true;
        this.selectAllText = this.$t("general.deselect_all");
      } else {
        let currentPageIds = this.items.data.map((t) => t.id);
        this.selectedIds = this.selectedIds.filter(
            (id) => !currentPageIds.includes(id)
        );
        this.allTraining = false;
        this.selectAllText = this.$t("general.select_all");
      }
    },
    applyFilter() {
      this.$emit("apply-filter", {
        page: this.page,
        search: this.searchQuery,
        order_by: this.orderBy,
      });
    },
    searchUser(searchQuery) {
      this.applyFilter();
    },
  },
  watch: {
    items: {
      handler(val) {
        if (val && typeof val === 'object' && !Array.isArray(val) && val.data) {
          this.initialLoading = false;
        }
      },
      immediate: true,
    },
    searchQuery: _.debounce(function () {
      this.isTyping = false;
    }, 1000),
    isTyping(value) {
      if (!value) {
        this.searchUser(this.searchQuery);
      }
    },
  },
  mounted() {
    this.applyFilter();
  },
};
</script>

<style scoped>
.catalog-training-card {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 6px;
}

.catalog-training-card__checkbox {
  flex-shrink: 0;
  padding-top: 0.25rem;
}

.catalog-training-card__checkbox input {
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
}

.catalog-training-card__image-wrap {
  flex-shrink: 0;
  width: 110px;
}

.catalog-training-image {
  width: 110px;
  height: 70px;
  object-fit: cover;
  object-position: left center;
  border-radius: 6px;
  display: block;
}

.catalog-training-card__body {
  flex: 1;
  min-width: 0;
}

.catalog-training-card__title {
  margin: 0 0 0.5rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.3;
}

.catalog-training-card__meta {
  margin: 0 0 0.5rem;
  font-size: 0.8rem;
}

.catalog-training-card__badge {
  display: inline-block;
  padding: 0.2rem 0.45rem;
  background: #f1f5f9;
  border-radius: 4px;
  font-size: 0.75rem;
}

.catalog-training-description {
  margin: 0.5rem 0 0;
  font-size: 0.8rem;
  color: #64748b;
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}
</style>
